import type { MouseEvent } from 'react';

import {
  BpkButtonV2,
  BUTTON_TYPES,
} from '@skyscanner/backpack-web/bpk-component-button';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import STYLES from './MapPriceMarkerButton.module.scss';

const cls = cssModules(STYLES);

export const MARKER_STATUSES = {
  unselected: 'unselected',
  selected: 'selected',
} as const;

export type Status = (typeof MARKER_STATUSES)[keyof typeof MARKER_STATUSES];

type Props = {
  label: string;
  accessibilityLabel: string;
  className?: string;
  onClick?: (event: MouseEvent) => void;
  buttonProps?: { [key: string]: string };
  status?: Status;
};

const MapPriceMarkerButton = (props: Props) => {
  const {
    accessibilityLabel,
    buttonProps,
    className,
    label,
    onClick,
    status = MARKER_STATUSES.unselected,
  } = props;

  const markerWrapperClassNames = cls('price-marker-button__wrapper');

  const classNames = cls(
    'price-marker-button',
    onClick && 'price-marker-button--dynamic',
    `price-marker-button-${status}`,
    className,
  );

  return (
    <BpkButtonV2
      type={BUTTON_TYPES.link}
      className={markerWrapperClassNames}
      onClick={onClick}
      aria-label={accessibilityLabel}
      {...buttonProps}
    >
      <div className={classNames}>
        <BpkText textStyle={TEXT_STYLES.label2}>
          <span>{label}</span>
        </BpkText>
      </div>
    </BpkButtonV2>
  );
};

export default MapPriceMarkerButton;
